import type { AppConfigInput } from '@nuxt/schema'

export default {
  skeleton: {
    base: 'bg-[var(--ui-bg-inverted)]/5 rounded-none',
  },
} as AppConfigInput['ui']
